import { render, staticRenderFns } from "./portfolioAS.vue?vue&type=template&id=04b6751b"
import script from "./portfolioAS.vue?vue&type=script&lang=js"
export * from "./portfolioAS.vue?vue&type=script&lang=js"
import style0 from "./portfolioAS.vue?vue&type=style&index=0&id=04b6751b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports